const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Action to save and fetch data
import { fetchposts, frontimmutable, frontimmute, buyvotesPayment, dataJudgeFetch, dataJudgeInsert, frontsingleimmute } from '../../actions/front_actions';

//Import Designs
import {
    Typography,
    Grid2,
    Card,
    CardContent,
    CardActions,
    Button,
    Divider,
    Backdrop,
    CircularProgress,
} from '@mui/material';


import ContestantTitle from './ContestantTitle.jsx';
import DisplayAuthorInfo from './DisplayAuthorInfo.jsx';
import ContestantDescription from './ContestantDescription.jsx';
import ContestantImage from './ContestantImage.jsx';
import VideoContestant from './VideoContestant.jsx';
import ContestantSocial from './ContestantSocial.jsx';
import CountButton from './CountButton.jsx';
import VoteButton from './VoteButton.jsx';
import ContestantCustom from './ContestantCustom.jsx';
import Paginationcontestants from './Paginationcontestants.jsx';

let current_date = null;
class ContestantList extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.state = { anchorEl: '', open: '', wait: 1, page_number: 1, authorid: '', butn_msg: null };
        this.contestantsContainer = React.createRef();
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    componentDidMount = () => {
        this._isMounted = true;
        this.setState({ wait: 1 });
        let wpvc_search = this.props.search();
        let pagin_val = 1;
        if (this.props.paginate_value != '') {
            pagin_val = this.props.paginate_value;
        }
        this.props.fetchposts(this.props.SITE_URL, this.props.short.id, this.props.short, pagin_val, "", wpvc_search).then(res => {
            if (this._isMounted) { this.setState({ wait: 0 }); }
        });
        current_date = this.props.currentdate;
    }

    clearauthor = () => {
        this.setState({ wait: 1, authorid: '', page_number: 1 });
        let wpvc_search = '';
        if (this.props.search != '') {
            wpvc_search = this.props.search();
        }
        let pagin_val = 1;
        this.props.fetchposts(this.props.SITE_URL, this.props.short.id, this.props.short, pagin_val, "", wpvc_search, '').then(res => {
            if (this._isMounted) { this.setState({ wait: 0 }); }
        });
    }

    getauthor = (author_id) => {
        this.setState({ wait: 1, authorid: author_id, page_number: 1 });
        let wpvc_search = this.props.search();
        let pagin_val = 1;
        if (this.props.paginate_value != '') {
            pagin_val = this.props.paginate_value;
        }
        this.props.fetchposts(this.props.SITE_URL, this.props.short.id, this.props.short, pagin_val, "", wpvc_search, author_id).then(res => {
            if (this._isMounted) { this.setState({ wait: 0 }); }
        });
    }

    pagination = (event, value) => {
        // this.setState({ wait: 1 });
        if (!Number.isInteger(value)) {
            value = event.target.value;
        }
        this.props.frontimmute('paginate_value', value);
        let wpvc_search = this.props.search();
        this.props.fetchposts(this.props.SITE_URL, this.props.short.id, this.props.short, value, "", wpvc_search).then(res => {
            if (this._isMounted) {
                this.contestantsContainer.current.scrollIntoView({ behavior: 'smooth' });
                this.setState({ page_number: value });
            }
        });
    }

    paginationbtn = (btn, value) => {
        // this.setState({ wait: 1 });
        if (btn == 'button') {
            value = value + 1;
        }
        let wpvc_search = this.props.search();
        this.props.fetchposts(this.props.SITE_URL, this.props.short.id, this.props.short, value, 'load', wpvc_search).then(res => {
            if (this._isMounted) { this.setState({ page_number: value }); }
        });
    }

    getVoteButtonText = (btnText, post_index) => {
        this.setState({ butn_msg: { [post_index]: btnText } });
    }

    render() {
        const { t } = this.props;
        const { wpvc_spacing, column_width, vote_title_alocation } = this.props.settings.style;
        const { box_bgcolor } = this.props.settings.color;
        let vote_count_showhide = (typeof this.props.settings.style !== "undefined") ? this.props.settings.style.vote_count_showhide : 'on';
        if (vote_count_showhide == null || typeof vote_count_showhide === 'undefined') {
            vote_count_showhide = 'on';
        }

        const xs_row = column_width || 12;
        const posts = this.props.post.posts;
        const allprops = this.props;
        let show_desc = null;
        let contest_type = null;
        if (typeof allprops.short.allcatoption !== "undefined") {
            show_desc = allprops.short.allcatoption.show_description;
            contest_type = this.props.short.contest_type;
        }
        const { imageProportion } = (typeof allprops.short.allcatoption.style !== "undefined") ? allprops.short.allcatoption.style : 'off';

        if ((posts != null && typeof posts === 'object') && (this.state.wait != 1) && (posts.length > 0)) {
            return (
                (<Grid2 container className="wpvc_showcontestant_container wpvc_list_container" ref={this.contestantsContainer}>
                    <Grid2 container size={12} direction="column" spacing={parseInt(wpvc_spacing)}
                        className={imageProportion === "on" ? 'wpvc_show_style_list wpvc_image_proportion' : 'wpvc_show_style_list'}>

                        {posts.map((object, i) =>
                            <Grid2
                                key={i}
                                className="wpvc_show_style_column"
                                size={{
                                    md: imageProportion === "on" ? 'auto' : parseInt(xs_row),
                                    sm: imageProportion === "on" ? 'auto' : 6,
                                    xs: imageProportion === "on" ? 'auto' : 12
                                }}>
                                <Card className="wpvc_card_column" style={{ backgroundColor: box_bgcolor || '#FFF' }}>
                                    {vote_title_alocation == 'on' &&
                                        <ContestantTitle {...allprops} singlepost={object} title_alocation="on_grid" view={this.props.view} changeauthor={this.getauthor} />
                                    }
                                    {contest_type != null && (contest_type == "photo" || contest_type == "essay") &&
                                        <ContestantImage {...allprops} singlepost={object} indexpost={i} view={this.props.view} currentdate={current_date} setButtonText={this.getVoteButtonText} butn_msg={this.state.butn_msg?.[i]} />
                                    }
                                    {contest_type != null && (contest_type == "video" || contest_type == "music") &&
                                        <VideoContestant {...allprops} singlepost={object} indexpost={i} view={this.props.view} currentdate={current_date} />
                                    }

                                    <CardContent className={(contest_type == "video" || contest_type == "music") ? "wpvc_card_video_content_column" : "wpvc_card_content_column"}>
                                        {vote_title_alocation == 'off' &&
                                            <ContestantTitle {...allprops} singlepost={object} view={this.props.view} changeauthor={this.getauthor} />
                                        }
                                        <DisplayAuthorInfo {...allprops} singlepost={object} view={this.props.view} changeauthor={this.getauthor} />
                                        {show_desc != "-1" && show_desc != "grid" &&
                                            <ContestantDescription {...allprops} singlepost={object} view={this.props.view} />
                                        }
                                        <ContestantCustom {...allprops} singlepost={object} view={this.props.view} currentdate={current_date} />
                                    </CardContent>

                                    <CardActions disableSpacing className="wpvc_card_actions_column">

                                        <Grid2 container justifyContent="flex-start">
                                            <div className="wpvc_contestant_vote_class">
                                                {
                                                    vote_count_showhide === 'on' &&
                                                    <CountButton {...allprops} singlepost={object} view={this.props.view} />
                                                }
                                                <VoteButton {...allprops} singlepost={object} indexpost={i} view={this.props.view} currentdate={current_date} setButtonText={this.getVoteButtonText} wait={this.state.wait} />
                                                {wp.hooks.applyFilters('wpvc_add_judge_btn', '', this.props, object)}
                                            </div>
                                        </Grid2>

                                        <Grid2 container justifyContent="flex-end" className="wpvc_contestant_social">
                                            <ContestantSocial {...allprops} singlepost={object} view={this.props.view} />
                                        </Grid2>

                                    </CardActions>

                                </Card>
                            </Grid2>
                        )}
                        <Paginationcontestants
                            {...allprops}
                            pagenumber={this.state.page_number}
                            changepagin={this.pagination}
                            changepaginbtn={this.paginationbtn}
                            select_value={this.props.paginate_value}
                        />
                    </Grid2>
                    {this.state.authorid != '' &&
                        <Button
                            variant="contained"
                            className="wpvc_clear_author_btns"
                            color="secondary"
                            onClick={() => this.clearauthor()}
                        >
                            {t("reset_gallery")}
                        </Button>
                    }
                </Grid2>)
            );
        } else if (posts == 'perpage') {
            return '';
        }
        else if (posts != null && posts.length == 0) {
            return (
                <Grid2 container className="wpvc_hr_contestants" >
                    <Typography align="center" variant="h6" component="h6">{t("no_contestants_found")}</Typography><Divider variant="middle" />
                </Grid2>
            )
        }
        else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }

    }
}

const settingstate = state => {
    return { post: state.wpvcfrontdata };
}

export default connect(settingstate, { frontimmutable, fetchposts, frontimmute, buyvotesPayment, dataJudgeFetch, dataJudgeInsert, frontsingleimmute })(withTranslation("translations")(ContestantList));

